import React, { useContext, useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import { Toaster } from "react-hot-toast";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import AppContainer from "../../../Components/Structure/AppContainer";
import ajaxStudent from "../../../util/remote/ajaxStudent";
import SchoolContext from "../../../Context/SchoolContext";
import SchoolFullyDormantAccounts from "../../../Components/Statistics/DormantAccounts/SchoolFullyDormantAccounts";
import SchoolBoothDormantAccounts from "../../../Components/Statistics/DormantAccounts/SchoolBoothDormantAccounts";
import SchoolPMDormantAccounts from "../../../Components/Statistics/DormantAccounts/SchoolPMDormantAccounts";

function SchoolDormantAccountsPage() {

  const [loadingPage, setLoadingPage] = useState(true);
  const [fullyDormantCount, setFullyDormantCount] = useState(false);
  const [boothDormantCount, setBoothDormantCount] = useState(false);
  const [pmDormantCount, setPMDormantCount] = useState(false);
    const { schoolDetails } = useContext(SchoolContext);
    const schoolID = schoolDetails.school_id;

  useEffect(() => {
    const fetchAll = async () => {
      setLoadingPage(true);
      await Promise.all([
        countFullyDormantAccounts(),
        countBoothDormantAccounts(),
        countPMDormantAccounts()
      ]);
      setLoadingPage(false);
    };
  
    fetchAll();
  }, []);

  const countFullyDormantAccounts = async () => {
      const server_response = await ajaxStudent.countSchoolFullyDormantAccounts(schoolID);
      if (server_response.status === "OK") {
        setFullyDormantCount(server_response.details);
      } else {
        setFullyDormantCount("404");
      }
  };

  const countBoothDormantAccounts = async () => {
      const server_response = await ajaxStudent.countSchoolBoothDormantAccounts(schoolID);
      if (server_response.status === "OK") {
        setBoothDormantCount(server_response.details);
      } else {
        setBoothDormantCount("404");
      }
  };

  const countPMDormantAccounts = async () => {
      const server_response = await ajaxStudent.countSchoolPMDormantAccounts(schoolID);
      if (server_response.status === "OK") {
        setPMDormantCount(server_response.details);
      } else {
        setPMDormantCount("404");
      }
  };


  


  return (
    <AppContainer title="Dormant Accounts">
      <Toaster position="top-center" reverseOrder={false} />
      {loadingPage ? (
              // Full page skeleton loader
              <div style={{ padding: 40 }}>
                <Skeleton height={40} width={300} style={{ marginBottom: 20 }} />
                <Skeleton height={200} style={{ marginBottom: 20 }} />
                <Skeleton count={5} height={30} style={{ marginBottom: 10 }} />
              </div>
            ) : (<>
      <div className="row logtat">
            <div className="col-lg-12" style={{padding:0}}>
              <div className="card custom-card" style={{paddingBottom:"10px"}}>
                <div className="card-body map-card gradient-my-blue">
                  <div className="item-title mb-2" style={{color:"white"}}><b>STATISTICS </b></div>
                  <div className="row">
                    <div className="col-xl-4 col-lg-12 col-sm-4 pr-0 pl-0 border-right">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{fullyDormantCount? fullyDormantCount.total_p:"..."}</span></h2>
                        <p className="mb-0 text-light"> Dormant (All Activity)</p>
                      </div>
                    </div>
                    <div className="col-xl-4 col-lg-12 col-sm-4 pr-0 pl-0 border-right">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{boothDormantCount? boothDormantCount.total_p:"..."}</span></h2>
                        <p className="mb-0 text-light">Dormant (Booth)</p>
                      </div>
                    </div>
                    <div className="col-xl-4 col-lg-12 col-sm-4 pr-0 pl-0">
                      <div className="text-center">
                        <h2 className="mb-1 number-font" style={{color:"white"}}><span className="counter">{pmDormantCount? pmDormantCount.total_p:"..."}</span></h2>
                        <p className="mb-0 text-light"> Dormant (Pocket Money)</p>
                      </div>
                    </div>
                    
                  </div>
                </div>
              </div>                  
            </div>
            
          
      </div>
      
      <div className="row">
      <div className="col-lg-12 col-md-12 mt-3">
              <div className="card height-auto">
                <div className="card-body">
                  <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                    <Row>
                      <Col sm={12}>
                        <Nav variant="pills" className="flex-row mb-1">
                          <Nav.Item>
                            <Nav.Link size="sm" eventKey="first">
                              Dormant (All Activity){" "}
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link size="sm" eventKey="second">
                              Dormant (Booth){" "}
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link size="sm" eventKey="third">
                              Dormant (Pocket Money){" "}
                            </Nav.Link>
                          </Nav.Item>
                         
                          
                        </Nav>
                      </Col>
                      <Col sm={12}>
                        <Tab.Content>
                          <Tab.Pane eventKey="first">
                            <SchoolFullyDormantAccounts/>
                           
                          </Tab.Pane>
                          <Tab.Pane eventKey="second">
                            <SchoolBoothDormantAccounts/>
                           
                          </Tab.Pane>
                          <Tab.Pane eventKey="third">
                            <SchoolPMDormantAccounts/>
                           
                          </Tab.Pane>
                          
                         
                        </Tab.Content>
                      </Col>
                    </Row>
                  </Tab.Container>  
                </div>
              </div>
          </div>
      </div></>
            )}
    </AppContainer>
  );
}

export default SchoolDormantAccountsPage;
